"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyPressedSelector = getKeyPressedSelector;
const keys_1 = require("../../utils/keys");
function getKeyPressedSelector(state) {
    return state.interactions.pointer.keyPressed ?? keys_1.noModifierKeysPressed;
}
//# sourceMappingURL=get_key_pressed.js.map